import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1e3dacf8 = () => interopDefault(import('../../../src/pages/account/index.vue' /* webpackChunkName: "pages/account/index" */))
const _284fa65c = () => interopDefault(import('../../../src/pages/add-carriage.vue' /* webpackChunkName: "pages/add-carriage" */))
const _42a1b7c7 = () => interopDefault(import('../../../src/pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _28d995bc = () => interopDefault(import('../../../src/pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _7908a585 = () => interopDefault(import('../../../src/pages/delivery-details.vue' /* webpackChunkName: "pages/delivery-details" */))
const _6608ba2a = () => interopDefault(import('../../../src/pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _52d369cc = () => interopDefault(import('../../../src/pages/payment.vue' /* webpackChunkName: "pages/payment" */))
const _13f717a8 = () => interopDefault(import('../../../src/pages/payment-key.vue' /* webpackChunkName: "pages/payment-key" */))
const _e7faa8c8 = () => interopDefault(import('../../../src/pages/privacy.vue' /* webpackChunkName: "pages/privacy" */))
const _4d036cfa = () => interopDefault(import('../../../src/pages/product.vue' /* webpackChunkName: "pages/product" */))
const _0f81e978 = () => interopDefault(import('../../../src/pages/search.vue' /* webpackChunkName: "pages/search" */))
const _099a89d0 = () => interopDefault(import('../../../src/pages/thank-you.vue' /* webpackChunkName: "pages/thank-you" */))
const _64d91158 = () => interopDefault(import('../../../src/pages/account/addresses.vue' /* webpackChunkName: "pages/account/addresses" */))
const _2f7cf723 = () => interopDefault(import('../../../src/pages/account/orders.vue' /* webpackChunkName: "pages/account/orders" */))
const _dccea2c6 = () => interopDefault(import('../../../src/pages/account/payment-methods.vue' /* webpackChunkName: "pages/account/payment-methods" */))
const _796f0fe1 = () => interopDefault(import('../../../src/pages/account/settings.vue' /* webpackChunkName: "pages/account/settings" */))
const _b769ea10 = () => interopDefault(import('../../../src/pages/auth/password-reset.vue' /* webpackChunkName: "pages/auth/password-reset" */))
const _ea932d84 = () => interopDefault(import('../../../src/pages/auth/register.vue' /* webpackChunkName: "pages/auth/register" */))
const _8fb5aa34 = () => interopDefault(import('../../../src/pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/account",
    component: _1e3dacf8,
    name: "account___eu"
  }, {
    path: "/add-carriage",
    component: _284fa65c,
    name: "add-carriage___eu"
  }, {
    path: "/auth",
    component: _42a1b7c7,
    name: "auth___eu"
  }, {
    path: "/cart",
    component: _28d995bc,
    name: "cart___eu"
  }, {
    path: "/delivery-details",
    component: _7908a585,
    name: "delivery-details___eu"
  }, {
    path: "/faq",
    component: _6608ba2a,
    name: "faq___eu"
  }, {
    path: "/payment",
    component: _52d369cc,
    name: "payment___eu"
  }, {
    path: "/payment-key",
    component: _13f717a8,
    name: "payment-key___eu"
  }, {
    path: "/privacy",
    component: _e7faa8c8,
    name: "privacy___eu"
  }, {
    path: "/product",
    component: _4d036cfa,
    name: "product___eu"
  }, {
    path: "/search",
    component: _0f81e978,
    name: "search___eu"
  }, {
    path: "/thank-you",
    component: _099a89d0,
    name: "thank-you___eu"
  }, {
    path: "/account/addresses",
    component: _64d91158,
    name: "account-addresses___eu"
  }, {
    path: "/account/orders",
    component: _2f7cf723,
    name: "account-orders___eu"
  }, {
    path: "/account/payment-methods",
    component: _dccea2c6,
    name: "account-payment-methods___eu"
  }, {
    path: "/account/settings",
    component: _796f0fe1,
    name: "account-settings___eu"
  }, {
    path: "/auth/password-reset",
    component: _b769ea10,
    name: "auth-password-reset___eu"
  }, {
    path: "/auth/register",
    component: _ea932d84,
    name: "auth-register___eu"
  }, {
    path: "/",
    component: _8fb5aa34,
    name: "index___eu"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
